import { createSlice } from '@reduxjs/toolkit'
import sessionSlice from './slices/session'

export default function createSliceWithLogout(options) {
  options.extraReducers = builder => {
    builder.addCase(
      sessionSlice.actions.logout,
      sessionSlice.caseReducers.logout,
    )
  }
  return createSlice(options)
}
